import { render, staticRenderFns } from "./rsv-msg.vue?vue&type=template&id=6807ceab&scoped=true&lang=pug&"
import script from "./rsv-msg.vue?vue&type=script&lang=js&"
export * from "./rsv-msg.vue?vue&type=script&lang=js&"
import style0 from "./rsv-msg.vue?vue&type=style&index=0&id=6807ceab&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807ceab",
  null
  
)

export default component.exports